import React from 'react'
import { cx } from '@/lib/utils'
import styles from './Container.module.scss'

type MaxWidth = 'sm' | 'md' | 'lg' | 'xl'

interface ContainerProps {
  children: React.ReactNode
  maxWidth?: MaxWidth
}

const maxWidthMap: Record<MaxWidth, string> = {
  sm: styles.maxSm,
  md: styles.maxMd,
  lg: styles.maxLg,
  xl: styles.maxXl,
}

export const Container: React.FC<ContainerProps> = ({ children, maxWidth = 'xl' }) => (
  <div className={cx(styles.container, maxWidthMap[maxWidth])}>
    {children}
  </div>
)
